/**
 * LBR2-D2 careers-page — pure client-side apply-form validator.
 *
 * Mirrors D1's server zod (`public-apply.validate.ts`): name required, phone ≥6,
 * email optional-but-valid. Pure (no React/DB) so it is unit-testable and shared
 * between the apply form and any future entry point. The server re-validates —
 * this is UX-only.
 */
export interface ApplyFormInput {
  applicantName: string;
  phone: string;
  email?: string;
  currentLocation?: string;
  experienceYears?: string;
  currentCtcLakh?: string;
  expectedCtcLakh?: string;
  noticePeriodDays?: string;
  notes?: string;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateApplyForm(input: ApplyFormInput): {
  ok: boolean;
  errors: Partial<Record<keyof ApplyFormInput, string>>;
} {
  const errors: Partial<Record<keyof ApplyFormInput, string>> = {};
  if (!input.applicantName?.trim()) errors.applicantName = 'Please enter your full name';
  const phone = (input.phone || '').trim();
  if (phone.length < 6) errors.phone = 'Please enter a valid phone number';
  if (input.email && input.email.trim() && !EMAIL_RE.test(input.email.trim())) {
    errors.email = 'Please enter a valid email address';
  }
  return { ok: Object.keys(errors).length === 0, errors };
}
